import { render } from "./SubSection.vue?vue&type=template&id=217aa6ad&ts=true"
import script from "./SubSection.vue?vue&type=script&lang=ts"
export * from "./SubSection.vue?vue&type=script&lang=ts"

import "./SubSection.vue?vue&type=style&index=0&id=217aa6ad&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__